<template>
    <div class="map">
        <div class="header">
            <el-row>
                <el-col>
                    <div class="page-title bold fnt-lg dark text-left">
                        Карта замеров
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="content">
            <el-row>
                <el-col :span="4" style="width: 14%" class="dashboard">
                    <el-row>
                        <el-col>
                            <div class="statistic-grid">
                                <div class="statistic-grid-title">
                                    Статистика
                                </div>
                                <template
                                    v-for="(stat, keyTime, index) in statistic"
                                >
                                    <div :key="keyTime" class="statistic-grid-digits">
                                        <el-tooltip popper-class="hint" effect="light" content="Назначено/Принято/Свободно/Всего" placement="right">
                                            <span>{{ stat.assigned }}/{{ stat.accepted }}/{{ stat.free }}/{{ stat.total }}</span>
                                        </el-tooltip>
                                    </div>
                                    <div :key="index" class="statistic-grid-mark">
                                        <div :class="['statistic-grid-time', `time-${keyTime}`]">
                                            {{ keyTime === 'all' ? '=' : keyTime }}
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row class="mt10">
                        <el-col>
                            <el-button
                                icon="el-icon-message"
                                @click="handleInformButtonClick"
                                type="warning"
                                class="send"
                                :disabled="!isCanEdit"
                            >
                                Сообщить замерщикам
                            </el-button>
                        </el-col>
                    </el-row>
                    <el-row class="mt10">
                        <el-col>
                            <div class="filter-title">
                                Поиск
                            </div>
                            <el-form label-position="top" class="filter-form">
                                <div class="measure-dates">
                                    <span class="common-title">Дата замера</span>
                                    <el-form-item label="от">
                                        <el-date-picker
                                            v-model="selectedDay"
                                            type="date"
                                            placeholder="дд.мм.гггг"
                                            format="dd.MM.yyyy"
                                            value-format="dd.MM.yyyy"
                                            :picker-options="pickerOptions"
                                            :clearable="false"
                                            size="mini"
                                            class="w100 date-field"
                                        />
                                    </el-form-item>
                                    <el-form-item label="до">
                                        <el-date-picker
                                            v-model="selectedDayTo"
                                            type="date"
                                            placeholder="дд.мм.гггг"
                                            format="dd.MM.yyyy"
                                            value-format="dd.MM.yyyy"
                                            :picker-options="pickerOptions"
                                            :clearable="false"
                                            size="mini"
                                            class="w100 date-field"
                                        />
                                    </el-form-item>
                                </div>
                                <el-form-item label="Замерщик">
                                    <el-select
                                        v-model="selectedMeasurerUserIds"
                                        placement="bottom"
                                        popper-class="popper-dropdown"
                                        multiple
                                        collapse-tags
                                        clearable
                                        placeholder="Все замерщики"
                                        size="mini"
                                    >
                                        <el-option v-for="measurer in measurers" :key="measurer.id" :label="measurer.full_name" :value="measurer.id" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="Менеджер">
                                    <el-select
                                        v-model="selectedResponsibleUserIds"
                                        placement="bottom"
                                        popper-class="popper-dropdown"
                                        multiple
                                        collapse-tags
                                        clearable
                                        placeholder="Все менеджеры"
                                        size="mini"
                                    >
                                        <el-option v-for="manager in managers" :key="manager.id" :label="manager.full_name" :value="manager.id" />
                                    </el-select>
                                </el-form-item>
                                <el-form-item>
                                    <el-button @click="getData" type="warning">
                                        Поиск
                                    </el-button>
                                </el-form-item>
                                <el-form-item>
                                    <span style="font-size: 16px">Найдено {{ deals.length }} замеров</span>
                                </el-form-item>
                            </el-form>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="20" id="map" style="min-height: 800px" />
            </el-row>
        </div>
    </div>
</template>

<script>
/*global ymaps*/
import '@/assets/styles/map.scss';
import moment from 'moment';
import localReferences from '@/helpers/localReferences';
import { pickerOptions } from '@/common/pickerOptions';

const colorMeasurementTimes = {
    '09-10': 'islands#pinkStretchyIcon',
    '12-13': 'islands#orangeStretchyIcon',
    '15-16': 'islands#blueStretchyIcon',
    '18-19': 'islands#redStretchyIcon'
};

const displayedTags = ['Перезамер', 'Повторник', 'Двух', 'Рекомендация'];

export default {
    name: 'MeasurementMap',
    data() {
        return {
            loading: false,
            pickerOptions,
            selectedDay: moment().add(1, 'days').format('DD.MM.YYYY'),
            selectedDayTo: moment().add(1, 'days').format('DD.MM.YYYY'),
            selectedMeasurerUserIds: [],
            selectedResponsibleUserIds: [],
            isMapReady: false,
            mapObject: {},
            collection: []
        };
    },
    computed: {
        deals() {
            return this.$store.state.map.deals;
        },
        measurers() {
            return this.$store.state.map.measurers.filter(employer => !employer.date_fired);
        },
        managers() {
            return this.$store.state.map.managers;
        },
        statistic() {
            return this.$store.state.map.statistic;
        },
        isCanEdit() {
            return this.$store.getters.isCanEditMap;
        }
    },
    methods: {
        getMapScript() {
            const mapScript = document.createElement('script');
            const options = { apiKey: this.$store.getters.yandexApiKey, lang: 'ru_RU', version: '2.1' };
            const mapLink = `https://api-maps.yandex.ru/${options.version}/?lang=${options.lang}${options.apiKey && `&apikey=${options.apiKey}`}`;
            mapScript.setAttribute('src', mapLink);
            mapScript.setAttribute('async', '');
            mapScript.setAttribute('defer', '');
            document.body.appendChild(mapScript);
            mapScript.onload = () => {
                this.initMap();
            };
        },
        initMap() {
            ymaps.ready(() => {
                this.mapObject = new ymaps.Map('map', {
                    center: localReferences.mapCenterCoordinates,
                    behaviors: ['default', 'scrollZoom'],
                    zoom: 10,
                    balloonPane: 'movableOuters',
                    controls: []
                });
                this.mapObject.events.add('balloonopen', () => {
                    this.mapObject.events.add('click', event => {
                        if (event.get('target') === this.mapObject) {
                            this.mapObject.balloon.close();
                        }
                    });
                });
                this.mapObject.container.fitToViewport();
                this.isMapReady = true;
                this.placeMarks();
            });
        },
        async placeMarks() {
            const dealsWithoutCoordinates = this.deals.filter(deal => deal.coordinates === null).filter(deal => deal.address !== null).filter(deal => deal.address !== '');
            for (const deal of dealsWithoutCoordinates) {
                await this.$store.dispatch('map/getCoordinatesByAddress', encodeURIComponent(deal.address)).then(
                    res => {
                        const coords = res || localReferences.mapCenterCoordinates;
                        this.$store.dispatch('map/updateCoordinates', { dealId: deal.id, coords: coords.join(' ') });
                    }).catch(
                    error => {
                        console.log(error);
                    });
            }
            this.mapObject.geoObjects.removeAll();
            this.collection = new ymaps.GeoObjectCollection();
            this.deals.forEach(deal => {
                this.collection.add(this.createMapMark(deal));
            });
            this.mapObject.geoObjects.add(this.collection);
            const mapBounds = this.mapObject.geoObjects.getBounds();
            if (mapBounds) {
                this.mapObject.setBounds(this.mapObject.geoObjects.getBounds());
                //Проверка автоматически выбранного масштаба карты
                if (this.mapObject.getZoom() > 12) {
                    this.mapObject.setZoom(12);
                }
            }
        },
        createBalloonHint(deal) {
            let hintContent = `Замер ${deal.actual_measurement_date} в ${deal.actual_measurement_time}ч.<br>Адрес: ${deal.address}<br>`;
            if (deal.measurer_user) {
                hintContent += `Замерщик: ${deal.measurer_user.full_name}<br>`;
            }
            if (deal.responsible_user) {
                hintContent += `Ответственный менеджер: ${deal.responsible_user.full_name}<br>`;
            }
            if (deal.volume) {
                hintContent += `Объем: ${deal.volume}`;
            }
            return hintContent;
        },
        createBalloonTitle(deal) {
            let iconContent = `${deal.measurer_user ? deal.measurer_user.full_name.substr(0, 3) : ''}`;
            if (deal.tags.length) {
                const filteredTags = deal.tags.filter(tag => displayedTags.includes(tag.name));
                if (filteredTags.length) {
                    iconContent += ' <b>#' + filteredTags.map(tag => tag.name.substr(0, 3)).join(' #') + '</b>';
                }
            }
            if (deal.difficult_metering) {
                iconContent += ' <b>#Сло</b>';
            }
            if (deal.finish) {
                iconContent += ' <b>#Отд</b>';
            }
            if (deal.re_measurement) {
                iconContent += ' <b>#Пер</b>';
            }
            return iconContent;
        },
        createBalloonContentHeader(deal) {
            let balloonContentTags = '';
            if (deal.tags.length) {
                const filteredTags = deal.tags.filter(tag => displayedTags.includes(tag.name));
                if (filteredTags.length) {
                    balloonContentTags += `<span class="label label-danger">${filteredTags.map(tag => tag.name).join('</span><span class="label label-danger">')}</span>`;
                }
            }
            let balloonContentHeader = `Замер ${deal.actual_measurement_date} в ${deal.actual_measurement_time} по адресу ${deal.address}`;
            if (deal.difficult_metering) {
                balloonContentHeader += ' + Сложный замер';
                balloonContentTags += '<span class="label label-danger">Сложный замер</span>';
            }
            if (deal.finish) {
                balloonContentTags += '<span class="label label-danger">Отделка</span>';
            }
            if (deal.re_measurement) {
                balloonContentTags += '<span class="label label-danger">Перезамер</span>';
            }
            balloonContentHeader += `<div>${balloonContentTags}</div>`;
            balloonContentHeader += deal.contract_number ? ` Номер договора: ${deal.contract_number};` : '';
            balloonContentHeader += deal.square_m2 ? ` Квадратура: ${deal.square_m2};` : '';
            balloonContentHeader += deal.volume ? ` Объем: ${deal.volume};` : '';
            return balloonContentHeader;
        },
        createBalloonContentBody(deal) {
            const measurers = this.prepareMeasurerListByDeal(deal);
            return measurers.map(measurer =>
                `<label class="employer-selector ${measurer.disabled ? 'employer-selector--disabled' : ''}">
                    <input class="employer-radio"
                        type="radio"
                        name="deal-${deal.id}-employers"
                        data-deal-id="${deal.id}"
                        data-measurer-id="${measurer.id}"
                        value="${measurer.id}"
                        ${measurer.assigned ? 'checked' : ''}
                        ${measurer.disabled ? 'disabled' : ''}
                    >
                    <span class="employer-select"></span>
                    ${measurer.full_name}${measurer.disabled ? ' (' + measurer.disabledComment + ')' : ''}
                </label>`
            ).join('');
        },
        createBalloonContentFooter(deal) {
            return `<a href="${this.$router.resolve({ name: 'deal-card', params: { id: deal.id } }).href}">
                                    Изменить в карточке сделки ${deal.id}
                        </a>`;
        },
        createMapMark(deal) {
            const MapBalloonContentLayout = ymaps.templateLayoutFactory.createClass(
                '<div id="balloon-{{properties.dealId}}" class="balloon-content">' +
                    '<div class="balloon-content__header">$[properties.balloonContentHeader]</div>' +
                    '<div class="balloon-content__body">$[properties.balloonContentBody]</div>' +
                    '<div class="balloon-content__footer">$[properties.balloonContentFooter]</div>' +
                '</div>'
            );
            const coords = deal.coordinates ? deal.coordinates.split(' ').map(coord => +coord) : localReferences.mapCenterCoordinates;
            const mapMark = new ymaps.Placemark(
                coords,
                {
                    iconContent: this.createBalloonTitle(deal),
                    hintContent: this.createBalloonHint(deal),
                    balloonContentHeader: this.createBalloonContentHeader(deal),
                    balloonContentBody: '',
                    balloonContentFooter: this.createBalloonContentFooter(deal),
                    dealId: deal.id
                }, {
                    balloonContentLayout: MapBalloonContentLayout,
                    preset: colorMeasurementTimes[deal.actual_measurement_time],
                    draggable: true,
                    balloonContentSize: [458, 320],
                    balloonLayout: 'default#imageWithContent',
                    balloonImageHref: '/assets/map-balloon-1px.png',
                    balloonImageOffset: [-229, -380],
                    balloonImageSize: [458, 380],
                    balloonShadow: false
                }
            );
            mapMark.events.add('balloonopen', () => {
                const changeMeasurerFunction = (event) => {
                    this.changeMeasurer(+event.target.dataset.dealId, +event.target.dataset.measurerId);
                };
                this.mapObject.panTo(mapMark.geometry.getCoordinates(), { useMapMargin: true });
                mapMark.properties.set('balloonContentBody', this.createBalloonContentBody(deal));
                let balloonContentElement = document.getElementById(`balloon-${deal.id}`);
                if (balloonContentElement === null) {
                    //Если вдруг при открытии первого балуна его содержимое доступно не сразу
                    setTimeout(() => {
                        balloonContentElement = document.getElementById(`balloon-${deal.id}`);
                        Array.prototype.forEach.call(balloonContentElement.getElementsByClassName('employer-radio'), (radioElement) => {
                            radioElement.addEventListener('change', changeMeasurerFunction);
                        });
                    }, 500);
                } else {
                    Array.prototype.forEach.call(balloonContentElement.getElementsByClassName('employer-radio'), (radioElement) => {
                        radioElement.addEventListener('change', changeMeasurerFunction);
                    });
                }
            });
            return mapMark;
        },
        updateCollection(dealId) {
            let changedMark = null;
            this.collection.each(mark => {
                if (mark.properties.get('dealId') === dealId) {
                    changedMark = mark;
                }
            });
            if (changedMark) {
                this.collection.remove(changedMark);
                this.collection.add(this.createMapMark(this.deals.find(deal => deal.id === dealId)));
            }
        },
        checkMeasurerAvailability(measurer, deal) {
            if (measurer.timesheets && measurer.timesheets.length) {
                const timesheet = measurer.timesheets.find(timesheet => timesheet.day === deal.actual_measurement_date.split('.').reverse().join('-'));
                if (timesheet && timesheet.status_id !== localReferences.timesheet.statuses.working) {
                    return { disabled: true, disabledComment: `${timesheet.status.name}` };
                }
            }
            if (measurer.reservations && measurer.reservations.length && deal.actual_measurement_time) {
                const reservation = measurer.reservations.find(reservation => reservation.day === deal.actual_measurement_date &&
                    reservation.time === deal.actual_measurement_time);
                if (reservation && reservation.is_reserved) {
                    return { disabled: true, disabledComment: 'бронь' };
                }
            }
            if (measurer.measurer_deals && measurer.measurer_deals.length && deal.actual_measurement_time) {
                const dealsAtSameDay = measurer.measurer_deals.filter(measurerDeal => measurerDeal.actual_measurement_date === deal.actual_measurement_date &&
                    measurerDeal.id !== deal.id);
                if (dealsAtSameDay && dealsAtSameDay.length) {
                    let conflictedDeal = dealsAtSameDay.find(measurerDeal => measurerDeal.actual_measurement_time === deal.actual_measurement_time);
                    if (conflictedDeal) {
                        return { disabled: true, disabledComment: `замер ${conflictedDeal.id}` };
                    }
                    const prevTime = localReferences.getPrevTime(deal.actual_measurement_time);
                    conflictedDeal = dealsAtSameDay.find(measurerDeal => measurerDeal.difficult_metering && measurerDeal.actual_measurement_time === prevTime);
                    if (prevTime && conflictedDeal) {
                        return { disabled: true, disabledComment: `замер ${conflictedDeal.id}` };
                    }
                    if (deal.difficult_metering) {
                        const nextTime = localReferences.getNextTime(deal.actual_measurement_time);
                        conflictedDeal = dealsAtSameDay.find(measurerDeal => measurerDeal.actual_measurement_time === nextTime);
                        if (nextTime && conflictedDeal) {
                            return { disabled: true, disabledComment: `замер ${conflictedDeal.id}` };
                        }
                    }
                }
            }
            if (deal.actual_measurement_time && this.statistic[deal.actual_measurement_time].free <= 0 && deal.measurer_user_id !== measurer.id) {
                return { disabled: true, disabledComment: 'занят' };
            }
            if (deal.actual_measurement_time === null) {
                return { disabled: true, disabledComment: 'в сделке нет времени замера' };
            }
            if (!this.isCanEdit) {
                return { disabled: true, disabledComment: 'нет прав на изменение' };
            }
            return { disabled: false, disabledComment: '' };
        },
        prepareMeasurerListByDeal(deal) {
            return this.measurers.map(measurer => {
                const availability = this.checkMeasurerAvailability(measurer, deal);
                return {
                    ...measurer,
                    assigned: measurer.id === deal.measurer_user_id,
                    disabled: availability.disabled,
                    disabledComment: availability.disabledComment
                };
            });
        },
        changeDate() {
            this.getData();
        },
        handleInformButtonClick() {
            this.$confirm('Отправить информацию по замерам?', 'Внимание', {
                confirmButtonText: 'Да',
                cancelButtonText: 'Отмена',
                type: '',
                center: true
            }).then(() => {
                this.informMeasurers();
            }).catch(() => {
            });
        },
        async changeMeasurer(dealId, measurerId) {
            try {
                this.loading = true;
                await this.$store.dispatch('map/changeMeasurer', {
                    dealId, measurerId
                });
                this.updateCollection(dealId);
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        async getData() {
            try {
                this.loading = true;
                await this.$store.dispatch('map/get', {
                    day: this.selectedDay,
                    dayTo: this.selectedDayTo,
                    measurers: this.selectedMeasurerUserIds,
                    managers: this.selectedResponsibleUserIds
                });
                if (this.isMapReady) {
                    this.placeMarks();
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        },
        async informMeasurers() {
            try {
                this.loading = true;
                const response = await this.$store.dispatch('map/informMeasurers', {
                    dealIds: this.deals.filter(deal => deal.measurer_user_id !== null).map(deal => deal.id)
                });
                let message = '<b>Замерщики не назначены</b>';
                let type = 'warning';
                let title = 'Внимание';
                const deals = Object.values(response.report);
                if (deals.length) {
                    message = deals.map(deal => `Сделка ${deal.id}, ${deal.measurer}<br><b>${deal.letter}</b><br>${deal.sms}`).join('<hr>');
                    type = 'success';
                    title = 'Успешно';
                }
                this.$notify({
                    duration: 10000,
                    title,
                    dangerouslyUseHTMLString: true,
                    message,
                    type
                });
            } catch (e) {
                console.log(e);
            } finally {
                this.loading = false;
            }
        }
    },
    mounted() {
        this.getData();
        this.getMapScript();
    }
};
</script>
